<mat-dialog-actions align = "end">
    <button mat-button mat-dialog-close>X</button>
</mat-dialog-actions>
<div mat-dialog-content>
<img [src]="data.url"/>
</div>